module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"lights-on-leyden","short_name":"Leyden","start_url":"/","background_color":"#0f2941","theme_color":"#0f2941","display":"minimal-ui","icon":"src/images/LeydenLogo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6cb20cf7261ce35dca50e75a2b45cff8"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
